import { j as s } from "../../../../_virtual/jsx-runtime.js";
const c = ({ ledengDescription: a, config: l }) => /* @__PURE__ */ s.jsxs("div", { className: "mt-6 pt-1 text-grey-600", children: [
  /* @__PURE__ */ s.jsx("div", { className: "flex items-center gap-8", children: /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2 mb-2.5 pl-3", children: [
    /* @__PURE__ */ s.jsx("span", { className: "text-xs text-muted-foreground", children: "#" }),
    /* @__PURE__ */ s.jsx("span", { className: "text-xs ml-1", children: a })
  ] }) }),
  /* @__PURE__ */ s.jsx("div", { className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-2", children: l.map((e) => /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ s.jsx(
      "div",
      {
        className: "h-3 w-6 rounded-l-3xl",
        style: { backgroundColor: e.color }
      }
    ),
    /* @__PURE__ */ s.jsx("span", { className: "text-xs", children: e.label })
  ] }, e.key)) })
] });
export {
  c as default
};
